import { isTrivvyProduct } from "./constants";

/* Account Settings (/enterprise-info) is shared with OurOffice but is included
   deliberately — isTrivvyProduct() omits the path, and the page needs the restyle. */
export const isBwaiScope = () => {
  if (isTrivvyProduct()) {
    return true;
  }
  const href = window.location.href || "";
  return href.indexOf("enterprise-info") > -1;
};

export default isBwaiScope;
